import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import { registerGuards } from "./utils/navigation-guards.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "浙江源广合科技有限公司"
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/register/Register.vue"),
    meta: {
      title: "注册中心"
    }
  },
  {
    path: "/yghdb/register",
    name: "RegisterYGHDB",
    component: () => import("@/views/register/yghdb/Register_YGHDB.vue"),
    meta: {
      title: "注册中心"
    }
  },
  {
    path: "/lease-info",
    name: "LeaseInfo",
    component: () => import("@/views/lease/LeaseInfo.vue"),
    meta: {
      title: "服务合同信息"
    }
  },
  {
    path: "/lease-detail",
    name: "LeaseDetail",
    component: () => import("@/views/lease/LeaseDetail.vue"),
    meta: {
      title: "合同详情"
    }
  },
  {
    path: "/repay-info/:leaseId/:htbh",
    name: "RepayInfo",
    component: () => import("@/views/repay/RepayInfo.vue"),
    meta: {
      title: "分期信息"
    }
  },
  {
    path: "/other-repay",
    name: "OtherRepay",
    component: () => import("@/views/repay/OtherRepay.vue"),
    meta: {
      title: "代缴还款"
    }
  },
  {
    path: "/self-repay",
    name: "SelfRepay",
    component: () => import("@/views/repay/SelfRepay.vue"),
    meta: {
      title: "在线还款"
    }
  },
  {
    path: "/pay-success",
    name: "PaySuccess",
    component: () => import("@/views/repay/PaySuccess.vue"),
    meta: {
      title: "支付成功"
    }
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("@/views/report/report.vue"),
    meta: {
      title: "报表"
    }
  }
];

const router = new VueRouter({
  routes
});

// 注册路由守卫
registerGuards(router);

export default router;
